import React from 'react';
import FilterColumn from 'components/Screening/FilterColumn';

interface IFilterOptions {
  setFilterMode: any;
  lensOpts: any;
  countryOpts: any;
  agencyOpts: any;
  listOpts: any;
  setSubmit: any;
  submit: any;
  commodityState: any;
  setCommodityState: any;
  countOpts: string[];
  agOpts: string[];
}

const CommodityFilterOptions: React.FC<IFilterOptions> = ({
  commodityState,
  setCommodityState,
  lensOpts,
  countryOpts,
  agencyOpts,
  listOpts,
  setSubmit,
  submit,
  countOpts,
  agOpts,
}) => {
  const { comLenses, countries, agencies, lists } = commodityState;

  return (
    <div className='filter-options-body-container'>
      {/* Lenses */}
      <FilterColumn
        location='Commodity'
        state={commodityState}
        type={'comLenses'}
        selections={comLenses}
        setSelections={setCommodityState}
        options={lensOpts.data}
        title='Lens'
        setSubmit={setSubmit}
        submit={submit}
        loading={false}
        icon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='18'
            viewBox='0 0 19 18'
            fill='none'
          >
            <path
              d='M16.5616 11.5058C14.4443 13.0121 11.6671 13.1794 9.40777 12M2.43833 6.49417C4.56079 4.98425 7.34633 4.81978 9.60862 6.00862M12.0303 10.5933C14.1953 9.22876 15.4489 6.7306 15.2007 4.13417M6.93638 7.42778C4.79174 8.79682 3.55219 11.2827 3.79908 13.8658M12.1452 7.60278C12.0454 5.04638 10.5087 2.71263 8.13658 1.62917M6.85671 10.4442C6.97334 12.9822 8.50571 15.294 10.8633 16.3708M14.8033 3.6967C17.7322 6.62563 17.7322 11.3744 14.8033 14.3033C11.8744 17.2322 7.12562 17.2322 4.1967 14.3033C1.26777 11.3744 1.26777 6.62562 4.1967 3.6967C7.12563 0.767767 11.8744 0.767767 14.8033 3.6967ZM11.6213 6.87868C12.7929 8.05025 12.7929 9.94975 11.6213 11.1213C10.4497 12.2929 8.55025 12.2929 7.37868 11.1213C6.20711 9.94975 6.20711 8.05025 7.37868 6.87868C8.55025 5.70711 10.4497 5.70711 11.6213 6.87868Z'
              stroke='#4895EF'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
      />
      <FilterColumn
        location='Commodity'
        state={commodityState}
        type={'countries'}
        selections={countries}
        setSelections={setCommodityState}
        options={countryOpts.data}
        loading={countryOpts.isLoading}
        title='Country Regulator'
        setSubmit={setSubmit}
        submit={submit}
        countOpts={countOpts}
        icon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='18'
            viewBox='0 0 19 18'
            fill='none'
          >
            <path
              d='M10.5 5.62478L8.25 7.87478L11.25 9.37478L9 11.6248M15.75 8.99978C15.75 12.6811 11.7345 15.3586 10.2735 16.2109C10.1074 16.3078 10.0244 16.3562 9.90726 16.3814C9.81633 16.4009 9.68367 16.4009 9.59274 16.3814C9.47557 16.3562 9.39255 16.3078 9.22651 16.2109C7.76547 15.3586 3.75 12.6811 3.75 8.99978V5.41298C3.75 4.81335 3.75 4.51353 3.84807 4.25581C3.93471 4.02814 4.07549 3.82499 4.25824 3.66393C4.46512 3.48161 4.74585 3.37634 5.3073 3.16579L9.32865 1.65779C9.48457 1.59932 9.56253 1.57008 9.64274 1.55849C9.71388 1.54821 9.78612 1.54821 9.85726 1.55849C9.93747 1.57008 10.0154 1.59932 10.1713 1.65779L14.1927 3.16579C14.7542 3.37634 15.0349 3.48161 15.2418 3.66393C15.4245 3.82499 15.5653 4.02814 15.6519 4.25581C15.75 4.51353 15.75 4.81335 15.75 5.41298V8.99978Z'
              stroke='#4895EF'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
      />
      <FilterColumn
        location='Commodity'
        state={commodityState}
        type={'agencies'}
        selections={agencies}
        setSelections={setCommodityState}
        options={agencyOpts.data}
        loading={agencyOpts.isLoading}
        title='Agency'
        setSubmit={setSubmit}
        submit={submit}
        agOpts={agOpts}
        icon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
          >
            <path
              d='M3.75 6.75026V12.7503M7.125 6.75026V12.7503M10.875 6.75026V12.7503M14.25 6.75026V12.7503M2.25 13.9503L2.25 14.5503C2.25 14.9703 2.25 15.1803 2.33175 15.3408C2.40365 15.4819 2.51839 15.5966 2.65951 15.6685C2.81994 15.7503 3.02996 15.7503 3.45 15.7503H14.55C14.97 15.7503 15.1801 15.7503 15.3405 15.6685C15.4816 15.5966 15.5963 15.4819 15.6683 15.3408C15.75 15.1803 15.75 14.9703 15.75 14.5503V13.9503C15.75 13.5302 15.75 13.3202 15.6683 13.1598C15.5963 13.0186 15.4816 12.9039 15.3405 12.832C15.1801 12.7503 14.97 12.7503 14.55 12.7503H3.45C3.02996 12.7503 2.81994 12.7503 2.65951 12.832C2.51839 12.9039 2.40365 13.0186 2.33175 13.1598C2.25 13.3202 2.25 13.5302 2.25 13.9503ZM8.73968 2.30811L3.18968 3.54144C2.85439 3.61595 2.68674 3.65321 2.5616 3.74336C2.45122 3.82288 2.36455 3.93093 2.31086 4.05593C2.25 4.19765 2.25 4.36939 2.25 4.71286L2.25 5.55026C2.25 5.9703 2.25 6.18032 2.33175 6.34075C2.40365 6.48187 2.51839 6.59661 2.65951 6.66851C2.81994 6.75026 3.02996 6.75026 3.45 6.75026H14.55C14.97 6.75026 15.1801 6.75026 15.3405 6.66851C15.4816 6.59661 15.5963 6.48187 15.6683 6.34075C15.75 6.18032 15.75 5.9703 15.75 5.55026V4.71287C15.75 4.36939 15.75 4.19765 15.6891 4.05593C15.6355 3.93093 15.5488 3.82288 15.4384 3.74336C15.3133 3.65321 15.1456 3.61595 14.8103 3.54144L9.26032 2.30811C9.16317 2.28652 9.1146 2.27573 9.06552 2.27142C9.02192 2.2676 8.97808 2.2676 8.93448 2.27142C8.8854 2.27573 8.83683 2.28652 8.73968 2.30811Z'
              stroke='#4895EF'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
      />
      <FilterColumn
        location='Commodity'
        state={commodityState}
        type={'lists'}
        selections={lists}
        setSelections={setCommodityState}
        options={listOpts.data}
        loading={listOpts.isLoading}
        title='List'
        setSubmit={setSubmit}
        submit={submit}
        icon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='18'
            viewBox='0 0 19 18'
            fill='none'
          >
            <path
              d='M16 2.25H2.5M16 15.75H2.5M4 9C4 8.30109 4 7.95163 4.11418 7.67598C4.26642 7.30843 4.55843 7.01642 4.92598 6.86418C5.20163 6.75 5.55109 6.75 6.25 6.75L12.25 6.75C12.9489 6.75 13.2984 6.75 13.574 6.86418C13.9416 7.01642 14.2336 7.30843 14.3858 7.67598C14.5 7.95163 14.5 8.30109 14.5 9C14.5 9.69891 14.5 10.0484 14.3858 10.324C14.2336 10.6916 13.9416 10.9836 13.574 11.1358C13.2984 11.25 12.9489 11.25 12.25 11.25L6.25 11.25C5.55109 11.25 5.20163 11.25 4.92597 11.1358C4.55843 10.9836 4.26642 10.6916 4.11418 10.324C4 10.0484 4 9.69891 4 9Z'
              stroke='#4895EF'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
      />
    </div>
  );
};

export default CommodityFilterOptions;
